import strFunc from "@/lib/lyg/string";
import DailyPrescribeDataFunc from "@/pcomponents/common/content/edu/daily_prescribe/func/data_func";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";

function DailyPrescribeArea(props: any) {
  let myProps = {
    subject_name: "",
    info: {},
    ...props
  };
  let subject_name = myProps.subject_name || "";
  let daily_prescribe_last_arr = myProps.info.daily_prescribe_last_arr || [];

  let daily_prescribe_info={
    ...DailyPrescribeDataFunc.default_info
  };

  for(let i=0;i<daily_prescribe_last_arr.length;i++){
    let item= daily_prescribe_last_arr[i];
    if(item.a_subject === subject_name&&!strFunc.is_empty(subject_name)){
      daily_prescribe_info={
        ...daily_prescribe_info,
        ...item
      };
    }
  }

  //<MultyLineTextView text={add_memo_info.a_wish_student}></MultyLineTextView>

  return (
    <>
      <tr>
        <th>issue</th>
        <td colSpan={3} >
          <MultyLineTextView text={daily_prescribe_info.a_issue}></MultyLineTextView>
        </td>
      </tr>
      <tr>
        <th>숙제Plan</th>
        <td colSpan={2} >
          <MultyLineTextView text={daily_prescribe_info.a_homework_plan}></MultyLineTextView>
        </td>
        <td>
          숙제량
          <MultyLineTextView text={daily_prescribe_info.a_homework_amount}></MultyLineTextView>
        </td>
      </tr>
      <tr>
        <th>진도Plan</th>
        <td colSpan={2} >
          <MultyLineTextView text={daily_prescribe_info.a_progress_plan}></MultyLineTextView>
        </td>
        <td>
          진도량
          <MultyLineTextView text={daily_prescribe_info.a_progress_amount}></MultyLineTextView>
        </td>
      </tr>
      <tr>
        <th>메모</th>
        <td colSpan={3} >
          <MultyLineTextView text={daily_prescribe_info.a_memo}></MultyLineTextView>
        </td>
      </tr>
    </>
  );
};
export default DailyPrescribeArea;